import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import PrimaryButton from "../../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import config from "../../../../../config";
import { BaseURL } from "../../../../../Hooks/URL";

function PreviousSubmissions({ mission }) {
  if (!mission?.submission || mission?.task?.type !== "mission") {
    return null;
  }

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 1100,
        mt: 4,
        mx: "auto",
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: 5,
          background: "#fff",
          boxShadow: "0 4px 32px 0 #b3b3b320",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: config.PRIMARY_COLOR,
            mb: 3,
            textAlign: "center",
          }}
        >
          Previous Submissions
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
            alignItems: "center",
            justifyContent: "space-between",
            p: 3,
            borderRadius: 3,
            background: "#f8f9fa",
            border: "1px solid #e9ecef",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#333",
                mb: 1,
              }}
            >
              Submission Details
            </Typography>
            <Typography
              sx={{
                color: "#666",
                fontSize: 16,
                mb: 1,
              }}
            >
              <strong>Number of Uploads:</strong>{" "}
              {mission.submission.numberOfUploads}
            </Typography>
            <Typography
              sx={{
                color: "#666",
                fontSize: 16,
                mb: 1,
              }}
            >
              <strong>Last Submitted:</strong>{" "}
              {new Date(mission.submission.submittedAt).toLocaleString()}
            </Typography>
          </Box>

          {mission?.task?.type === "mission" && (
            <Box sx={{ display: "flex", gap: 2 }}>
              <PrimaryButton
                classBtn={"center"}
                btnType={"button"}
                text={"Download Submission"}
                click={() => {
                  if (mission.submission.submittedFilePath) {
                    window.open(
                      `${BaseURL}/${mission.submission.submittedFilePath}`,
                      "_blank"
                    );
                  }
                }}
                style={{
                  textTransform: "capitalize",
                  borderRadius: "5px",
                  color: config.SECONDARY_COLOR,
                  backgroundColor: config.PRIMARY_COLOR,
                  fontWeight: 700,
                  fontSize: 16,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                  minWidth: "180px",
                }}
              />
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

export default PreviousSubmissions;

